module.exports = window.PleskUiLibrary;